import React from "react";
import { Link } from "react-router-dom";

function WhatWeOffer({ data }) {
  return (
    <section className="section">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <h2 className="section-title">What We Offer</h2>
            <p className="section-subtitle">
              We focus on following industry best practices and using the latest, cutting-edge technology, providing the strongest foundation for your transition. Here is how we've achieved this feat.
            </p>
          </div>
        </div>

        <div className="row">
          {data.map((item, index) => {
            const Icon = item.icon;
            return (
              <div className="col-lg-6 mb-4" key={index}>
                <div className="service-card">
                  <div className="service-icon">
                    <Icon className="icon" />
                  </div>
                  <div className="service-content">
                    <h4 className="service-title">
                      {item.title}
                    </h4>
                    <p className="service-description">{item.desc}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default WhatWeOffer;
